import { render, staticRenderFns } from "./QACriterionEditor.vue?vue&type=template&id=ce41a6b8&scoped=true"
import script from "./QACriterionEditor.vue?vue&type=script&lang=js"
export * from "./QACriterionEditor.vue?vue&type=script&lang=js"
import style0 from "./QACriterionEditor.vue?vue&type=style&index=0&id=ce41a6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce41a6b8",
  null
  
)

export default component.exports